import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = ({ authRequired = true }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  if (!authRequired || isAuthenticated) {
    return <Outlet />;
  }
  return <Navigate to="/" replace />;
};

export default PrivateRoute;
